import { render, staticRenderFns } from "./MandateStep5.vue?vue&type=template&id=4b25def0&scoped=true&"
import script from "./MandateStep5.vue?vue&type=script&lang=js&"
export * from "./MandateStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25def0",
  null
  
)

export default component.exports